<template>
  <svg
    width="22"
    height="22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(-1 -1)"
      fill="none"
      fill-rule="evenodd"
    >
      <path d="M0 0h24v24H0z" />
      <circle
        stroke="#FFF"
        stroke-width="3"
        :fill="color"
        stroke-linecap="round"
        stroke-linejoin="round"
        cx="12"
        cy="12"
        r="9"
      />
      <path
        stroke="#FFF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15.3639615 10.3455842l-3.8183766 3.8183766-2.54558442-2.5455844"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IcTickFilled',

  data () {
    return {
      color: APP_THEME.palette.primary.main
    }
  }
}
</script>
